// Presentation choices shared by TRAVEL and TRAVEL2. Missing settings preserve
// the original theme layout; menu-only rules never remove a destination page.
import {buildMenuUrl, isExternalUrl} from './normalizeMenuUrl';
const sectionKeys = {home_hotels: 'hotels', home_kosher: 'kosher'};

export function travelBannersPlacement(travel) {
    return travel?.homepage?.bannersPlacement === 'top' ? 'top' : 'bottom';
}

export function isTravelHomeSectionMenuOnly(context, key) {
    const sections = context?.travel?.homepage?.menuOnlySections;
    return context?.page?.type === 'HOME' && Array.isArray(sections)
        && Object.prototype.hasOwnProperty.call(sectionKeys, key) && sections.includes(sectionKeys[key]);
}

export function isTravelHomeLinkHidden(context, rawUrl) {
    if (context?.page?.type !== 'HOME' || typeof rawUrl !== 'string' || !rawUrl.trim()) return false;
    try {
        const base = new URL(context.org?.BASE_WEB_URL || 'https://unisoft.local');
        const raw = rawUrl.trim();
        const resolved = raw.startsWith('//') ? new URL(raw, base).href : raw;
        // Use the same tenant roots and SaaS-to-custom-domain rewriting as the
        // actual link. Sharing an origin does not make another org internal.
        if (isExternalUrl(resolved, context.org)) return false;
        const url = new URL(buildMenuUrl(resolved, context.org), base);
        // External links that happen to use the same path are unrelated.
        if (url.origin !== base.origin) return false;
        const section = url.pathname.match(/\/travel\/(hotels|kosher-places)(?:\/|$)/)?.[1];
        const key = section === 'hotels' ? 'home_hotels' : section === 'kosher-places' ? 'home_kosher' : null;
        return !!key && isTravelHomeSectionMenuOnly(context, key);
    } catch {
        return false;
    }
}
